module.exports = __webpack_public_path__ + "static/media/securittyenginner.12d44590.png";